const common = {
  nav: {
    categories: "Kategorier",
    guides: "Guides",
    shipping: "Forsendelse",
    qc: "Kvalitetskontrol",
    reviews: "Anmeldelser",
    comparisons: "Sammenligninger",
    safety: "Sikkerhed",
    contact: "Kontakt",
    about: "Om",
    products: "Produkter",
  },
  languages: {
    en: "English",
    fr: "Français",
    da: "Dansk",
    de: "Deutsch",
  },
  hero: {
    h1: "AllChinaBuy Spreadsheet — Opdag produkter, fund og indkøbsressourcer",
    subtitle: "Udforsk de seneste AllChinaBuy spreadsheet-ressourcer, produktfund, indkøbsvejledninger, forsendelsesinformation, QC-tips og pålidelige ressourcer — organiseret på ét sted.",
    primaryCta: "Udforsk AllChinaBuy Spreadsheet",
    secondaryCta: "Gennemse indkøbsvejledninger",
    trustText: "Uafhængig ressource • Flersprogede guides • Opdateret indhold",
    mainCta: "Besøg hovedwebsitet",
  },
  categories: {
    title: "Shoppingkategorier",
    shoes: "Sko",
    hoodies: "Hoodies/Sweatre",
    tshirts: "T-Shirts",
    jackets: "Jakker",
    pants: "Bukser/Shorts",
    headwear: "Hovedbeklædning",
    sets: "Sæt",
    underwear: "Undertøj/Underbukser",
    jersey: "Trøjer",
    accessories: "Tilbehør",
    bags: "Tasker",
    belts: "Bælter",
    perfumes: "Parfumer",
    other: "Andre ting",
  },
  whatIs: {
    h2: "Hvad er AllChinaBuy Spreadsheet?",
    description: "AllChinaBuy Spreadsheet er en praktisk måde at opdage organiserede produktressourcer, produktlinks, kategorier og indkøbsinformation på. I stedet for at søge på tværs af flere kilder, kan du bruge vores ressourcehub til at udforske AllChinaBuy-relaterede produkter, guides og praktisk indkøbsinformation på ét sted.",
    cta: "Udforsk Spreadsheetet",
  },
  resources: {
    h2: "Udforsk populære AllChinaBuy-ressourcer",
    spreadsheet: "AllChinaBuy Spreadsheet",
    finds: "AllChinaBuy Fund",
    products: "AllChinaBuy Produkter",
    shippingResource: "AllChinaBuy Forsendelse",
    qcResource: "AllChinaBuy QC",
    warehouse: "AllChinaBuy Lager",
    review: "AllChinaBuy Anmeldelse",
    coupon: "AllChinaBuy Kupon",
  },
  guides: {
    h2: "AllChinaBuy indkøbsvejledninger",
    reviewGuide: "AllChinaBuy Anmeldelse",
    shippingCost: "Forsendelsesomkostningsguide",
    warehouseGuide: "Lagerguide",
    qcGuide: "QC-guide",
    safetyGuide: "Sikkerhedsguide",
    couponGuide: "Kuponguide",
  },
  latestFinds: {
    h2: "Seneste AllChinaBuy-fund",
    cta: "Udforsk AllChinaBuy-fund",
  },
  shipping: {
    h2: "AllChinaBuy Forsendelse, QC & Lagerinformation",
    description: "Forstå AllChinaBuy-forsendelsesmuligheder, lagerprocesser og kvalitetskontrolbetragtninger, før du placerer din ordre. Vores guides dækker forsendelsesmetoder, potentielle omkostninger, sporing og risikostyringsråd.",
  },
  comparison: {
    h2: "AllChinaBuy Sammenligninger",
    description: "Sammenlign AllChinaBuy med andre populære indkøbsagenter for at træffe en informeret beslutning om din købsoplevelse.",
  },
  safety: {
    h2: "Er AllChinaBuy legitimt og sikkert?",
    description: "Vi giver neutrale, evidensbaserede råd om AllChinaBuy-sikkerhed, legitimitet og risikofaktorer. Vores sikkerhedsguide dækker betalingssikkerhed, sælgerverifikation og køberbeskyttelsestips.",
    cta: "Læs AllChinaBuy-sikkerhedsguiden",
  },
  whyUs: {
    h2: "Hvorfor bruge vores AllChinaBuy Spreadsheet-hub?",
    organized: "Organiserede ressourcer",
    organizedDesc: "Alle produktlinks, kategorier og guides på ét praktisk sted.",
    discovery: "Nem produktopdagelse",
    discoveryDesc: "Find det, du har brug for, hurtigt uden at søge på flere sites.",
    practical: "Praktiske guides",
    practicalDesc: "Trin-for-trin indkøbsguides, forsendelsestips og QC-råd.",
    shippingInfo: "Forsendelsesinformation",
    shippingInfoDesc: "Forstå forsendelsesmetoder, omkostninger og tidslinjer, før du køber.",
    multilingual: "Flersproget indhold",
    multilingualDesc: "Få adgang til guides på engelsk, fransk, dansk og tysk.",
    updated: "Regelmæssige opdateringer",
    updatedDesc: "Vores indhold opdateres regelmæssigt for at afspejle de seneste oplysninger.",
  },
  bottomCta: {
    h2: "Begynd at udforske AllChinaBuy",
    primaryCta: "Udforsk AllChinaBuy Spreadsheet",
    secondaryCta: "Besøg hovedwebsitet",
    description: "Udforsk det komplette AllChinaBuy-regneark, gennemse kuraterede produktfund og få adgang til detaljerede købsvejledninger på dit foretrukne sprog.",
  },
  articles: {
    h2: "AllChinaBuy Spreadsheet-artikler",
    readMore: "Læs artikel",
  },
  footer: {
    disclaimer: "Ansvarsfraskrivelse: Dette er en uafhængig informationsressource og er ikke det officielle AllChinaBuy-websted. AllChinaBuy er et varemærke tilhørende dens respektive ejere.",
    spreadsheet: "AllChinaBuy Spreadsheet",
    resources: "Ressourcer",
    categories: "Kategorier",
    guides: "Guides",
    reviews: "Anmeldelser",
    shipping: "Forsendelse",
    warehouse: "Lager",
    qc: "QC",
    comparisons: "Sammenligninger",
    safety: "Sikkerhed",
    about: "Om",
    contact: "Kontakt",
    privacy: "Privatlivspolitik",
    terms: "Servicevilkår",
    editorial: "Redaktionel politik",
    language: "Sprog",
    copyright: "© 2026 AllChinaBuy Spreadsheet Hub. Alle rettigheder forbeholdes.",
  },
  common: {
    readMore: "Læs mere",
    learnMore: "Lær mere",
    explore: "Udforsk",
    view: "Se",
    updated: "Opdateret",
  },
  allChinaBuy: {
    title: "AllChinaBuy Spreadsheet",
    buyNow: "Køb nu",
  },

  products: {
    title: "Alle produkter",
    description: "Gennemse vores kuraterede samling af AllChinaBuy-produkter. Klik på et element for at besøge produktsiden og købe via kaspreadsheet.com.",
    disclaimer: "Dette er en uafhængig ressource. Produkter linker til kaspreadsheet.com til køb.",
    filterAll: "Alle kategorier",
    searchPlaceholder: "Søg efter produkter...",
    productCount: "{{count}} produkt",
    productCount_plural: "{{count}} produkter",
    noResults: "Ingen produkter fundet",
    noResultsDesc: "Prøv at justere din søgning eller kategorifilter",
    clearFilters: "Ryd filtre",
    buyNow: "Køb nu",
    buy: "Køb",
    viewAll: "Se alle produkter",
    moreProducts: "Leder du efter flere produkter?",
    moreProductsDesc: "Besøg hovedwebsitet kaspreadsheet.com for det komplette katalog med tusindvis af flere produkter.",
  },
  meta: {
    siteTitle: "AllChinaBuy Spreadsheet Hub — Produkter & Indkøbsvejledninger",
    description: "Din uafhængige ressourcehub for AllChinaBuy spreadsheet-ressourcer, produktfund, indkøbsvejledninger, forsendelsesinformation og QC-tips. Udforsk organiserede kategorier og guides på flere sprog.",
  },

  article: {
    home: "Hjem",
    lastUpdated: "Sidst opdateret",
    disclaimer: "Ansvarsfraskrivelse",
    disclaimerText: "Dette er en uafhængig informationsressource og er ikke det officielle AllChinaBuy-websted. Alle oplysninger er kun til uddannelsesmæssige formål. Bekræft altid detaljer direkte hos sælgere, før du foretager køb.",
    faqTitle: "Ofte stillede spørgsmål",
    readyToExplore: "Klar til at udforske?",
    ctaDesc: "Besøg hovedwebsitet AllChinaBuy for at gennemse det komplette produktkatalog og begynde at handle.",
    relatedArticles: "Relaterede artikler",
    backToHome: "Tilbage til forsiden",
    ctaText: "Fortsæt til hovedwebsitet",
  },
};

export default common;